import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'

import { EuiPage, EuiPageBody } from '@elastic/eui'

import { MasterCampaignPage } from 'features/campaigns/masterCampaigns/MasterCampaignPage'
import { MasterCampaignsPage } from 'features/campaigns/masterCampaigns/MasterCampaignsPage'

import PrivateRoute from '../../../components/PrivateRoute'

const MasterCampaignRoutes: React.FC = () => {
  const { path } = useRouteMatch()
  return (
    <EuiPage className='euiPage--platform'>
      <EuiPageBody>
        <Switch>
          <PrivateRoute exact path={path}>
            <MasterCampaignsPage />
          </PrivateRoute>
          <PrivateRoute path={`${path}/:masterCampaignId`}>
            <MasterCampaignPage />
          </PrivateRoute>
        </Switch>
      </EuiPageBody>
    </EuiPage>
  )
}

export default MasterCampaignRoutes
